import { render, staticRenderFns } from "./BoundaryEx.vue?vue&type=template&id=2e845b12&"
import script from "./BoundaryEx.vue?vue&type=script&lang=js&"
export * from "./BoundaryEx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports